<nz-card nzTitle="Plan Progressor Monitor" [nzLoading]="pageLoading">
  <div class="flex flex-wrap items-center gap-4 mb-4">
    <label nz-checkbox [(ngModel)]="filterHandback">Needs handback</label>
    <label nz-checkbox [(ngModel)]="filterTerminal">Terminal options needed</label>
    <label nz-checkbox [(ngModel)]="filterDisengage">Disengaged</label>
    <label nz-checkbox [(ngModel)]="filterDormant">Dormant</label>
    <label nz-checkbox [(ngModel)]="filterRebaseline">Rebaseline offer needed</label>
    <label nz-checkbox [(ngModel)]="filterRampWithoutDestination"
      >Ramp without destination (authoring gap)</label
    >
    <label nz-checkbox [(ngModel)]="includeTestUsers">Include test users</label>
    <button nz-button nzType="primary" [disabled]="tableLoading" (click)="applyFilters()">Apply</button>
    <button nz-button nzType="default" [disabled]="tableLoading" (click)="clearFilters()">Clear</button>
  </div>

  <nz-table
    #monitorTable
    [nzData]="data"
    [nzLoading]="tableLoading"
    [nzFrontPagination]="false"
    [nzTotal]="totalRecords"
    [nzPageIndex]="page"
    [nzPageSize]="pageSize"
    [nzPageSizeOptions]="pageSizeOptions"
    (nzPageIndexChange)="nzPageIndexChange($event)"
    (nzPageSizeChange)="nzPageSizeChange($event)"
  >
    <thead>
      <tr>
        <th>
          User
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="emailMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Partner
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="partnerMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Tags
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="tagsMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Objective
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="titleMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>Description</th>
        <th>
          Status
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="statusMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>
          Progress
          <nz-filter-trigger [nzActive]="true" [nzDropdownMenu]="progressMenu">
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
        <th>Flags</th>
        <th>Last Hold Reason</th>
        <th>Last Modified</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of data">
        <td>
          <div>{{ row.userName || '(unknown)' }}</div>
          <div class="text-xs text-gray-500">{{ row.userEmail || row.userId }}</div>
        </td>
        <td>{{ row.partnerId || '-' }}</td>
        <td>
          <nz-tag *ngFor="let tag of row.userTags">{{ tag }}</nz-tag>
          <span *ngIf="!row.userTags?.length">-</span>
        </td>
        <td>
          <div>{{ row.displayTitle || row.objectiveId }}</div>
          <div class="text-xs text-gray-500">
            {{ row.objectiveTitle }}
            <nz-tag *ngIf="row.objectiveIsArchived" nzColor="red">Catalog objective retired</nz-tag>
          </div>
        </td>
        <td>{{ row.displayDescription || '-' }}</td>
        <td>{{ row.status }}</td>
        <td>{{ row.latestSnapshot?.progress ?? '-' }}</td>
        <td>
          <nz-tag nzColor="red" *ngIf="row.flags.needsGoalAgentHandback">Handback</nz-tag>
          <nz-tag nzColor="red" *ngIf="row.flags.terminalOptionsNeeded">Terminal</nz-tag>
          <nz-tag nzColor="orange" *ngIf="row.flags.disengagementMenuNeeded">Disengaged</nz-tag>
          <nz-tag nzColor="blue" *ngIf="row.flags.dormant">Dormant</nz-tag>
          <nz-tag nzColor="orange" *ngIf="row.flags.rebaselineOfferNeeded">Rebaseline</nz-tag>
          <nz-tag nzColor="magenta" *ngIf="row.flags.rampWithoutDestinationFlagged"
            >Ramp w/o destination</nz-tag
          >
        </td>
        <td>{{ row.lastHoldReason || '-' }}</td>
        <td>{{ row.lastModifiedAt | date: 'medium' }}</td>
      </tr>
    </tbody>
  </nz-table>
</nz-card>

<nz-dropdown-menu #emailMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="userEmailSearch"
          nz-input
          placeholder="Search by email"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #partnerMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="partnerIdSearch"
          nz-input
          placeholder="Search by partner"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #tagsMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onUserTagsFilterChange($event)">
      <div *ngFor="let tag of userTagsOptions" nz-row class="m-1">
        <label nz-checkbox [nzValue]="tag" [ngModel]="userTagsFilterValues.includes(tag)">
          {{ tag }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #titleMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <div class="text-xs text-gray-500 mb-1">Title contains</div>
        <input
          [(ngModel)]="displayTitleSearch"
          nz-input
          placeholder="Search by title"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row>
      <div nz-col>
        <div class="text-xs text-gray-500 mb-1">Objective expert title contains</div>
        <input
          [(ngModel)]="expertTitleSearch"
          nz-input
          placeholder="Search by expert title"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #statusMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onStatusFilterChange($event)">
      <div *ngFor="let status of statusOptions" nz-row class="m-1">
        <label nz-checkbox [nzValue]="status" [ngModel]="statusFilterValues.includes(status)">
          {{ status }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-dropdown-menu #progressMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <nz-checkbox-wrapper (nzOnChange)="onProgressBucketFilterChange($event)">
      <div *ngFor="let bucket of progressBucketOptions" nz-row class="m-1">
        <label
          nz-checkbox
          [nzValue]="bucket"
          [ngModel]="progressBucketFilterValues.includes(bucket)"
        >
          {{ bucket === UserObjectivesProgressBucket.NO_DATA ? 'No data' : bucket + '%' }}
        </label>
      </div>
    </nz-checkbox-wrapper>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzSize="small" nzType="primary" (click)="applyFilters()">
          Ok
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
